module.exports = __webpack_public_path__ + "img/notification_center_alt.e0123e7e.png";